_getPortalShare